<template>
  <div class="customer-header-wrapper">
    <div class="customer-header-left">
      <ulu-logo :brand="brand" class="customer-logo" />
      <div class="customer-info">
        <h2 class="customer-title">
          {{ name }}{{ company_country ? ', ' + company_country : '' }}
        </h2>
        <div class="contact-info">
          <div v-if="contact_first_name || contact_last_name">
            {{ contact_first_name }} {{ contact_last_name }}{{ contact_email ? ',' : '' }}
          </div>
          <div v-if="contact_email">{{ contact_email }}</div>
        </div>
      </div>
    </div>

    <div class="customer-header-right">
      <button
        v-if="web_app_id && !registration_accepted_at"
        class="registration-btn"
        @click="showEmailModal = true"
      >
        {{ registration_sent_at ? $t("globals.re_send_registration_email") : $t("globals.send_registration_email") }}
      </button>
      <b-btn
        v-if="web_app_id"
        size="sm"
        variant="outline-secondary"
        class="webapp-btn"
        @click="goToWebApp"
      >
        {{ "WebApp (id: " + web_app_id + ")" }}
      </b-btn>
    </div>
    <b-modal
      centered
      :visible="showEmailModal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="container-fluid">
        <b-row>
          <b-col>
            <h4>{{ $t("globals.are_you_sure") }}</h4>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <b-btn
              style="float: right; margin: 0.3em;"
              @click="sendRegistrationEmail"
              variant="success"
              :disabled="!web_app_id"
            >
              {{ $t("globals.yes") }}
            </b-btn>
            <b-btn
              style="float: left; margin: 0.3em;"
              @click="showEmailModal = false"
              variant="warning"
            >
              {{ $t("globals.cancel") }}
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "ulu-logo": () => import("@/components/common/Logo.vue")
  },
  props: {
    refresh: Function,
    web_app_id: Number,
    brand: String,
    name: String,
    registration_sent_at: String,
    registration_accepted_at: String,
    company_country: String,
    contact_first_name: String,
    contact_last_name: String,
    contact_email: String
  },
  data() {
    return {
      showEmailModal: false
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    goToWebApp() {
      window.open(
        `${this.getWebAppUrl}/admin/companies/${this.web_app_id}`,
        "_blank"
      );
    },
    sendRegistrationEmail() {
      const data = {
        query: `
          mutation CustomerSendRegistrationLink($company_id: ID!, $company_country: String) {
            res: CustomerSendRegistrationLink(company_id: $company_id, company_country: $company_country)
          }
        `,
        variables: {
          company_id: this.web_app_id,
          company_country: this.company_country
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.showEmailModal = false;
        this.refresh();
      });
    }
  },
  computed: {
    ...mapGetters(["getWebAppUrl"])
  }
};
</script>

<style scoped>
.customer-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.customer-header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
}

.customer-logo {
  flex-shrink: 0;
}

.customer-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.customer-title {
  font-size: 24px;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
  line-height: 1.2;
}

.contact-info {
  font-size: 14px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.customer-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.registration-btn {
  padding: 6px 16px;
  background-color: #f57c00;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.registration-btn:hover {
  background-color: #ef6c00;
}

.webapp-btn {
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s;
}

@media (max-width: 768px) {
  .customer-header-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .customer-header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .customer-header-right {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
